import { render, staticRenderFns } from "./DrzavaBase.vue?vue&type=template&id=3f0ba6a8&scoped=true&"
import script from "./DrzavaBase.vue?vue&type=script&lang=js&"
export * from "./DrzavaBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0ba6a8",
  null
  
)

export default component.exports